// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__38A-N","footer":"ChangeClinic_footer__15SW4"};